import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { LinkedService } from './linkedservice';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.sparkJobDefinitionLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.SparkJobDefinitionActivityLabel),
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.SparkJobDefinitionActivityLabel)
    ]
})
export class TridentSparkJobDefinitionLinkedService extends LinkedService { }